module.exports = __webpack_public_path__ + "img/logo_pis.ae115be8.png";